module.exports = __webpack_public_path__ + "static/toggleintegrations-123ca1705140ddf390e498f199e4146c.png";